<template>
  <li class="course-item">
    <a>
      <img :src="src+'@153h_252w_2e_90Q'" />
      <h2>{{title}}</h2>
      <h3>{{subTitle}}</h3>
    </a>
  </li>
</template>
<script>
  export default {
      props: {
          src: {
              type: String,
              required: true
          },
          title: {
              type: String,
              required: true
          },
          subTitle: {
              type: String,
              required: true
          }
      }
  };
</script>
<style lang="postcss">
.course-item {
  width: 272px;
  height: 227px;
  float: left;
  &:hover {
    a img {
      box-shadow: 0 4px 8px rgba(40, 40, 40, 0.2);
    }
  }
  a {
    margin-right: 20px;
    padding-top: 20px;
    display: block;
    &:hover,
    &:focus {
      color: #37a6fc;
      text-decoration: none;
      h2,
      h3 {
        color: #37a6fc;
      }
    }
    img {
      display: block;
      width: 100%;
      height: 153px;
      box-shadow: none;
    }
    h2,
    h3 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: normal;
    }
    h2 {
      font-size: 16px;
      color: #152c3c;
      line-height: 25px;
      margin-top: 9px;
      margin-bottom: 3px;
    }
    h3 {
      color: #93999f;
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CourseItem.vue?18113379